import { borderCss, Box } from '@talos/kyoko';
import styled from 'styled-components';

export const PillBox = styled(Box)`
  background: ${({ theme }) => theme.backgroundDefaultButton};
  padding: ${({ theme }) => theme.spacing2}px ${({ theme }) => theme.spacing8}px;

  ${({ theme }) => borderCss(theme.borderRadiusHuge)}
  line-height: 1;

  border: 1px solid ${({ theme }) => theme.borderColorDefaultButton};

  &:hover {
    background: ${({ theme }) => theme.backgroundDefaultButtonHover};
  }
`;
